import React from 'react';
import { ILegalTransactionFullObject } from '../../Interfaces/ILegalTransaction';
import { ITaskFullObject } from '../../Interfaces/ITask';
import { ILegalClient } from '../../Interfaces/ILegalClient';
import { IUser } from '../../Interfaces/IUser';
import { IUserGroup } from '../../Interfaces/IUserGroup';
import { TaskTable } from '../../Task/TaskTable';

interface IProps {
  legalTransaction: ILegalTransactionFullObject;
  tasks: ITaskFullObject[];
  setTasks: React.Dispatch<React.SetStateAction<ITaskFullObject[]>>;
  legalClients: ILegalClient[];
  users: IUser[];
  userGroups: IUserGroup[];
}

export const TasksTab: React.FC<IProps> = ({
  legalTransaction,
  tasks,
  setTasks,
  legalClients,
  users,
  userGroups,
}) => {
  return (
    <TaskTable
      legalTransaction={legalTransaction}
      tasks={tasks}
      setTasks={setTasks}
      legalClients={legalClients}
      userGroups={userGroups}
      users={users}
    />
  );
};
